module.exports = __webpack_public_path__ + "img/icon_popup_close.075c05e0.svg";